import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { USER_TYPE_CLIENT } from 'src/app/models/usersTypes.model';
import { environment } from 'src/environments/environment';
import { Marque } from 'src/app/models/marque.model';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class FooterComponent implements OnInit {
    protected auth = inject(AuthService);

    isClient: boolean = false;

    get nowYear(): number {
        return new Date().getFullYear();
    }

    get environment() {
        return environment;
    }

    get clientFooterBrand(): Marque | undefined {
        if (!this.auth.isClient() || this.auth.userBrand.length !== 1) {
            return undefined;
        }

        return this.auth.userBrand[0];
    }

    get footerBackgroundColor(): string | null {
        return this.normalizeColor(this.clientFooterBrand?.theme?.topbarBackground);
    }

    get footerTextColor(): string | null {
        return this.normalizeColor(this.clientFooterBrand?.theme?.topbarText);
    }

    ngOnInit(): void {
        this.auth.onAuthenticated.subscribe(async u => {
            if (u && u.attributes_name) {
                if (u.attributes_name.includes(USER_TYPE_CLIENT)) {
                    this.isClient = true;
                }
            }
        });
    }

    private normalizeColor(color?: string): string | null {
        const value = color?.trim();
        return value ? value : null;
    }
}
